// extracted by mini-css-extract-plugin
export var imgBox = "Introductions-module--imgBox--86eb3";
export var overWrap = "Introductions-module--overWrap--1ae83";
export var overview_content_wrap = "Introductions-module--overview_content_wrap--d37ee";
export var overview_image_wrap = "Introductions-module--overview_image_wrap--2a392";
export var overview_info_wrap = "Introductions-module--overview_info_wrap--86bdd";
export var overview_title = "Introductions-module--overview_title--a75cc";